export const useFormatUrlWithHttps = (url: string) => {
  if (url && !/^https?:\/\//i.test(url) && /^www\./i.test(url)) {
    return `https://${url}`
  }
  return url
}
